import React from 'react'
import { IconPlayerPause, IconPlayerPlayFilled } from '@tabler/icons-react'
import classNames from 'classnames'

import { Button } from '@/components/buttons/Button'

export const PlayPauseButton = ({
  isDisabled,
  disabledTooltip = 'Cannot Play Audio',
  togglePlayState,
  isPlaying,
  autoFocus,
}) => {
  return (
    <Button
      small
      autoFocus={autoFocus}
      brand
      circular
      onClick={togglePlayState}
      data-testid="play-pause-button"
      aria-label={isPlaying ? 'Pause' : 'Play'}
      className={classNames('play-pause-button', { disabled: isDisabled })}
      disabled={isDisabled}
      disabledTooltip={disabledTooltip}
      tooltip={isPlaying ? 'Pause' : 'Play'}
    >
      {isPlaying ? <IconPlayerPause aria-hidden /> : <IconPlayerPlayFilled aria-hidden />}
    </Button>
  )
}
